/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const newKioskAuthOverlaySchema = z.object({
	overlay_screen: z.string().nullable(),
	lt_primary_color: z.string(),
	background_color: z.string(),
	lt_background_addinational_color: z.string(),
	border_color: z.string(),
	muted_text_color: z.string(),
	lt_badge_text: z.string().nullable(),
	common_title: z.string().nullable(),
	lt_subtitle: z.string().nullable(),
	lt_personal_account_title: z.string().nullable(),
	lt_description: z.string().nullable(),
	common_auth_btn: z.string().nullable(),
	lt_skip_auth: z.string().nullable(),
	gm_name_placeholder: z.string().nullable(),
	gm_name_hint: z.string().nullable(),
	gm_continue_button: z.string().nullable(),
	lt_hint_text: z.string().nullable(),
	lt_hint_subtext: z.string().nullable(),
	lt_confetti_emojis: z.any(),
	common_success_title: z.string().nullable(),
	common_success_message: z.string().nullable(),
	common_success_emoji: z.string().nullable(),
	common_success_footer_note: z.string().nullable(),
	kiosk_auth_promo_code: z.boolean(),
	kiosk_auth_promo_code_len: z.int(),
	kiosk_auth_promo_code_text: z.string().nullable(),
	kiosk_auth_promo_code_keyboard: z.string().nullable(),
});
